import { render, staticRenderFns } from "./Sidompul.vue?vue&type=template&id=7ed02b8b&scoped=true&"
import script from "./Sidompul.vue?vue&type=script&lang=js&"
export * from "./Sidompul.vue?vue&type=script&lang=js&"
import style0 from "./Sidompul.vue?vue&type=style&index=0&id=7ed02b8b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed02b8b",
  null
  
)

export default component.exports